import { createStyleSheet } from '@shared-ui/theme'

export const useCreateStyles = createStyleSheet(() => ({
  button: {
    alignItems: 'center',
    borderRadius: 999,
    justifyContent: 'center',
  },
}))
